import { render, staticRenderFns } from "./ThePageHeader.vue?vue&type=template&id=2923e75d&scoped=true&"
import script from "./ThePageHeader.vue?vue&type=script&lang=js&"
export * from "./ThePageHeader.vue?vue&type=script&lang=js&"
import style0 from "./ThePageHeader.vue?vue&type=style&index=0&id=2923e75d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2923e75d",
  null
  
)

export default component.exports